<template>
  <div class="radio-btns-wrapper">
    <div>
      <label class="top-label">{{ label }}</label>
      <slot ref="additionalInfo" name="info"></slot>
    </div>
    <div :class="listClasses">
      <label
        v-for="(option, index) in options"
        :key="index"
        :for="groupId != null ? option.name + '-' + groupId : option.name"
        class="radio-container"
      >
        <input
          type="radio"
          :id="groupId != null ? option.name + '-' + groupId : option.name"
          :value="option.value"
          @change="updateValue(option.value)"
          :checked="JSON.stringify(option.value) == JSON.stringify(value)"
        />
        <div class="radio-check-indicator"></div>
        <span :class="[{ 'light-label': lightLabel }]">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  model: {
    event: "change",
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    //OPTIONS EXPECT {
    // value: "..."
    // name: "..."
    // label: "..."
    // }
    options: Array,
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null,
    },
    groupId: {
      type: [String, Number],
      default: null,
    },
    listClasses: String,
    lightLabel: Boolean,
  },
  methods: {
    updateValue(value) {
      this.$emit("change", value);
    },
  },
  created() {
    this.$emit("change", this.value);
  },
};
</script>

<style lang="less">
.radio-btns-wrapper {
  padding: 10px 0;
  position: relative;
  font-weight: 500;
  span {
    font-size: 14px;
    color: #383838;
  }
  label {
    color: #8f979c;
  }
  .top-label {
    color: var(--text-grey-primary);
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transform-origin: 0 0;
    transform: translate(0px, 3px) scale(0.8);
  }
}

input[type="radio"]:focus ~ .radio-check-indicator::before {
  content: "";
  width: 20px;
  height: 20px;
  border-radius: 50% 50%;
  position: absolute;
  top: -3px;
  left: -3px;
  background: none;
  border: 1px solid var(--orange-web);
}
.radio-container {
  display: block;
  position: relative;
  padding: 0;
  cursor: pointer;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked ~ .radio-check-indicator {
      background-color: var(--orange-web);
    }
    &:checked ~ .radio-check-indicator:after {
      display: block;
    }
  }

  &:hover input ~ .radio-check-indicator {
    filter: brightness(1.05);
  }

  .radio-check-indicator {
    position: absolute;
    top: 1px;
    left: 0;
    height: 14px;
    width: 14px;
    background-color: #e2e2e2;
    border-radius: 50%;

    &:after {
      content: "";
      position: absolute;
      display: none;
    }

    &:after {
      top: 5px;
      left: 5px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: var(--alabaster);
    }
  }

  span {
    margin-left: 24px;
  }
}
.radio-btns-wrapper span.light-label {
  color: #8f979c;
  font-size: 12px;
  font-weight: bold;
}
</style>
